import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
} from '@angular/core';
import { STATUSES } from '@models/statuses';
import { select } from '@ngxs/store';
import { EnvelopeService } from '@services/envelope/envelope.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ButtonComponent } from '@ui/button/button.component';
import {
	DropdownComponent,
	DropdownItem,
} from '@ui/dropdown/dropdown.component';
import { UI_TYPES } from 'src/app/ui/modal/modal.types';

enum STATUS_DROPDOWN_ACTION_TYPES {
	GO_TO_PACKAGE = 'go-to-package',
	RENAME = 'rename',
	DOWNLOAD = 'download',
	CANCEL = 'cancel',
	DELETE = 'delete',
	EDIT_SIGNORS = 'edit-signors',
}

@Component({
	selector: 'app-e-signing-status-actions-dropdown',
	standalone: true,
	imports: [ButtonComponent, DropdownComponent],
	templateUrl: './e-signing-status-actions-dropdown.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ESigningStatusActionsDropdownComponent {
	private envelopeService = inject(EnvelopeService);
	private matterId_ = select(SelectedMatter.id);
	public envelopeId = input<string>();
	public status = input<STATUSES>();
	public size = input<ButtonComponent['size']>('sm');

	public renameClick = output<string>();
	public envelopeActions = computed(() => {
		const envelopeId = this.envelopeId();
		const status = this.status();

		const actions: DropdownItem[] = [
			{
				id: STATUS_DROPDOWN_ACTION_TYPES.DOWNLOAD,
				title: { label: 'Download', icon: 'download' },
				action: () => this.envelopeService.downloadEnvelope(envelopeId),
			},
			{
				id: STATUS_DROPDOWN_ACTION_TYPES.RENAME,
				title: { label: 'Rename', icon: 'cursor-text' },
				action: () => this.renameClick.emit(envelopeId),
			},
		];

		actions.push(
			[STATUSES.SENT_ALT, STATUSES.IN_PROGRESS].includes(status)
				? {
						id: STATUS_DROPDOWN_ACTION_TYPES.CANCEL,
						title: { label: 'Cancel', icon: 'mail-x' },
						type: UI_TYPES.DANGER,
						action: () =>
							this.envelopeService.openPopConfirmForCancel(
								this.matterId_(),
								envelopeId,
							),
					}
				: {
						id: STATUS_DROPDOWN_ACTION_TYPES.DELETE,
						title: { label: 'Delete', icon: 'trash' },
						type: UI_TYPES.DANGER,
						action: () =>
							this.envelopeService.openPopConfirmForDelete(
								this.matterId_(),
								envelopeId,
							),
					},
		);

		return actions;
	});
}
